import { ADD_QUERY_PARAMS, SET_QUERY_PARAMS } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.queryParams, action) {
  switch (action.type) {
    case SET_QUERY_PARAMS:
      return action.payload;
    case ADD_QUERY_PARAMS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/queryParams/reducer.js